import { render } from "./EmptyTableMessage.vue?vue&type=template&id=0a13d852&scoped=true"
const script = {}

import "./EmptyTableMessage.vue?vue&type=style&index=0&id=0a13d852&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a13d852"]])

export default __exports__